export enum TalkToAnalystFields {
  QuestionAbout = 'about',
  QuestionToAnalyst = 'comment',
}
